import * as ROUTES from '../routes';


const Navigations = [
    {
        title: "Transactions",
        icon: "mdi-wallet",
        to: ROUTES.TRANSACTIONS,
        mini: false,
        permissions: ['can_view_transactions'],
        subNav: [
            {
                title: 'Transactions',
                to: ROUTES.TRANSACTIONS,
                icon: 'mdi-list-status'
            },
            {
                title: 'Withdrawals',
                to: ROUTES.WITHDRAWALS,
                icon: 'mdi-credit-card-minus'
            }
        ]
    },
]

export default Navigations